module.exports = __webpack_public_path__ + "img/phone.07e4cdaf.gif";